import React from "react";

import svg from "../../assets/images/icons/Form Controls/Tabs container.svg";

export const TabsContainerIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Tabs Container"}
    />
);
